import { Directive, HostListener, input, output } from '@angular/core';

export type SortOrder = 'asc' | 'desc' | 'default';

export interface SortOutput<T> {
	sortField: T;
	sortOrder: SortOrder;
}

@Directive({
	selector: '[libSortable]',
	standalone: true,
})
export class SortableDirective<T> {
	sortableField = input.required<T>();
	sortableFields = input.required<(T)[]>();
	onSortChanged = output<SortOutput<T>>();

	private sortSettings: SortOutput<T> = {
		sortField: '' as unknown as T,
		sortOrder: 'default',
	};

	@HostListener('click')
	onClick() {
		const { sortOrder } = this.sortSettings;

		this.sortSettings = {
			sortField: this.sortableField(),
			sortOrder: sortOrder === 'desc' ? 'asc' : 'desc',
		};

		this.onSortChanged.emit(this.sortSettings);
	}
}
